var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{class:'btn btn-lg btn-secondary ms-lg-3 mt-3 mt-lg-0 ' + _vm.searcher_btn_class(),on:{"click":function($event){return _vm.toggle_searcher()}}},[_c('i',{staticClass:"fas fa-search"})])
}
var staticRenderFns = []

export { render, staticRenderFns }